import { Bot } from "lucide-react"
import { cn } from "@/lib/utils"

interface AgentsCTAProps {
  onClick: () => void
  className?: string
}

export function AgentsCTA({ onClick, className }: AgentsCTAProps) {
  return (
    <button
      onClick={onClick}
      title="Agents"
      className={cn(
        "flex w-full items-center gap-3 rounded-lg bg-gradient-to-r from-rose-500 to-violet-500 px-3 py-3 text-white transition-opacity hover:opacity-90",
        "group-data-[collapsible=icon]:h-8 group-data-[collapsible=icon]:w-8 group-data-[collapsible=icon]:p-0 group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:mx-auto",
        className
      )}
    >
      <div className="flex items-center justify-center shrink-0">
        <Bot className="h-5 w-5 group-data-[collapsible=icon]:h-4 group-data-[collapsible=icon]:w-4" />
      </div>
      <span className="text-sm font-bold group-data-[collapsible=icon]:hidden">Agents</span>
      <span className="ml-auto h-2 w-2 rounded-full bg-green-400 group-data-[collapsible=icon]:hidden" />
    </button>
  )
}
